import React from 'react';
import { SilenceList } from '../components/SilenceList';
import { Silence } from '../../../../../api/cansense/silenceApi';

interface SilencesTabProps {
  silences: Silence[];
  loading: boolean;
  onCreateSilence: () => void;
  onExtend: (id: number) => void;
  onDelete: (id: number) => void;
}

export function SilencesTab({
  silences,
  loading,
  onCreateSilence,
  onExtend,
  onDelete,
}: SilencesTabProps) {
  return (
    <SilenceList
      silences={silences}
      loading={loading}
      onCreateSilence={onCreateSilence}
      onExtend={onExtend}
      onDelete={onDelete}
    />
  );
}
